import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material'
import { useTranslate } from 'ra-core'
import { ReferenceArrayField, ReferenceField, SingleFieldList, useRecordContext } from 'react-admin'

import { useShowStyles } from '../resources/common/show'

const ReferenceListField = ({ reference, source, icon: Icon, labelPrefix }) => {
  const showClasses = useShowStyles()
  const record = useRecordContext()
  const translate = useTranslate()

  const numberOfItems = record[source]?.length

  const label =
    (labelPrefix ? `${translate(labelPrefix)} ` : '') +
    numberOfItems +
    ' ' +
    translate(`resources.${reference}.name`, numberOfItems)

  if (numberOfItems === 0) {
    return (
      <Typography variant="span" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {Icon && <Icon fontSize="small" />}
        {label}
      </Typography>
    )
  }

  return (
    <ReferenceArrayField reference={reference} source={source}>
      <Accordion
        disableGutters
        elevation={0}
        square
        sx={{
          backgroundColor: 'transparent',
          boxShadow: 'none',
          '&:before': {
            display: 'none',
          },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ fontSize: 16 }} />}
          sx={{
            minHeight: 'unset',
            paddingY: 0,
            paddingX: 0,
            '& .MuiAccordionSummary-content': {
              margin: 0,
            },
            '&:hover': {
              backgroundColor: 'transparent',
            },
          }}
        >
          <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {Icon && <Icon fontSize="small" />}
            {label}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <SingleFieldList linkType={false} direction="column">
            <li style={{ ...showClasses.unorderedListItem, marginLeft: '12px' }}>
              <ReferenceField reference={reference} source="id" link="show" />
            </li>
          </SingleFieldList>
        </AccordionDetails>
      </Accordion>
    </ReferenceArrayField>
  )
}

export default ReferenceListField
